module.exports = __webpack_public_path__ + "img/current.bd4536e2.png";